import config from 'config';

import { BUILDER_MODELS } from '~/builder/constants/models';
import { getBuilderJsonSSR } from '~/builder/utils/getBuilderJsonSSR';
import useBuilderJson from '~/builder/utils/useBuilderJson';

function getValueByDelimiterKey(obj, key) {
  if (!obj || !key) {
    return null;
  }

  const keys = key.split('.'); // Split the key by the delimiter
  let current = obj;

  for (const k of keys) {
    const currentVal = current[k];
    if (currentVal === undefined) {
      return undefined; // Key not found
    }
    current = currentVal;
  }

  return current;
}

// priority: privateConfig > config
export function getConfigValue(id, privateConfig) {
  const privateValue = getValueByDelimiterKey(privateConfig, id);
  const configValue = config.has(id) ? config.get(id) : undefined;

  return privateValue || configValue;
}

export function getConfigValueSSR(ctx, id) {
  const privateConfig = getBuilderJsonSSR({
    modelName: BUILDER_MODELS.PRIVATE_CONFIG,
    ctx,
  });

  return getConfigValue(id, privateConfig?.builderJson?.data?.config);
}

export function useConfigValue(id) {
  const privateConfig = useBuilderJson({
    modelName: BUILDER_MODELS.PRIVATE_CONFIG,
  });

  return getConfigValue(id, privateConfig?.builderJson?.data?.config);
}
